import feedbackUrls from '../constants';

import templateUrl from './feedbackComponent.html';

class FeedbackComponentCtrl {
  constructor(Authentication, $http, $attrs) {
    'ngInject';

    Object.assign(this, { Authentication, $http, $attrs });
  }

  $onInit() {
    this.origin = this.$attrs.origin;
  }

  toggleFeedbackModal() {
    this.modalVisible = !this.modalVisible;
  }

  closeFeedbackModal() {
    this.modalVisible = false;
  }

  submitFeedback() {
    if (this.message) {
      this.sendFeedback(this.message);
      this.feedbackSubmitted = true;
    }
  }

  sendFeedback(message) {
    return this.$http({
      method: 'POST',
      url: feedbackUrls[this.$attrs.origin],
      data: [
        `Name=${encodeURIComponent(this.Authentication.user.fullname)}`,
        `Email=${encodeURIComponent(this.Authentication.user.email)}`,
        `Opinion=${encodeURIComponent(message || '')}`,
        `Org=${encodeURIComponent(this.Authentication.user.org.name)}`,
        `OrgId=${encodeURIComponent(this.Authentication.user.org.id)}`,
        `UserId=${encodeURIComponent(this.Authentication.user.id)}`,
      ].join('&'),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }
}

export default {
  templateUrl,
  controller: FeedbackComponentCtrl,
  controllerAs: 'ctrl',
};
